import { get } from "lodash";
import {
  hasReportingRole,
  hasAdminRole,
  isInternalSupportUser,
} from "src/services/auth";

const shouldShowReportsLink = ({
  workspace,
  isReportingInfraProvisioned,
  user,
}) => {
  const reportsURL = get(workspace, "config.tenantConfig.reportsUrl");
  const canUserAccessReporting =
    isInternalSupportUser(user) || hasAdminRole(user) || hasReportingRole(user);

  if (workspace?.isActive) {
    return !!(reportsURL && canUserAccessReporting);
  }

  return !!(
    workspace?.isReportingEnabled &&
    isReportingInfraProvisioned &&
    reportsURL &&
    canUserAccessReporting
  );
};

export default shouldShowReportsLink;
